import TENavLink from './TENavLink';

export default TENavLink;
